export default {
    "AF": "Afghanistan",
    "AX": "Aland Islands",
    "AL": "Albania",
    "DZ": "Algeria",
    "AS": "AmericanSamoa",
    "AD": "Andorra",
    "AO": "Angola",
    "AI": "Anguilla",
    "AQ": "Antarctica",
    "AG": "Antigua and Barbuda",
    "AR": "Argentina",
    "AM": "Armenia",
    "AW": "Aruba",
    "AU": "Australia",
    "AT": "Austria",
    "AZ": "Azerbaijan",
    "BS": "Bahamas",
    "BH": "Bahrain",
    "BD": "Bangladesh",
    "BB": "Barbados",
    "BY": "Belarus",
    "BE": "Belgium",
    "BZ": "Belize",
    "BJ": "Benin",
    "BM": "Bermuda",
    "BT": "Bhutan",
    "BO": "Bolivia, Plurinational State of",
    "BA": "Bosnia and Herzegovina",
    "BW": "Botswana",
    "BR": "Brazil",
    "IO": "British Indian Ocean Territory",
    "BN": "Brunei Darussalam",
    "BG": "Bulgaria",
    "BF": "Burkina Faso",
    "BI": "Burundi",
    "KH": "Cambodia",
    "CM": "Cameroon",
    "CA": "Canada",
    "CV": "Cape Verde",
    "KY": "Cayman Islands",
    "CF": "Central African Republic",
    "TD": "Chad",
    "CL": "Chile",
    "CN": "China",
    "CX": "Christmas Island",
    "CC": "Cocos (Keeling) Islands",
    "CO": "Colombia",
    "KM": "Comoros",
    "CG": "Congo",
    "CD": "Congo, The Democratic Republic of the Congo",
    "CK": "Cook Islands",
    "CR": "Costa Rica",
    "CI": "Cote d'Ivoire",
    "HR": "Croatia",
    "CU": "Cuba",
    "CY": "Cyprus",
    "CZ": "Czech Republic",
    "DK": "Denmark",
    "DJ": "Djibouti",
    "DM": "Dominica",
    "DO": "Dominican Republic",
    "EC": "Ecuador",
    "EG": "Egypt",
    "SV": "El Salvador",
    "GQ": "Equatorial Guinea",
    "ER": "Eritrea",
    "EE": "Estonia",
    "ET": "Ethiopia",
    "FK": "Falkland Island",
    "FO": "Faroe Islands",
    "FJ": "Fiji",
    "FI": "Finland",
    "FR": "France",
    "GF": "French Guiana",
    "PF": "French Polynesia",
    "GA": "Gabon",
    "GM": "Gambia",
    "GE": "Georgia",
    "DE": "Germany",
    "GH": "Ghana",
    "GI": "Gibraltar",
    "GR": "Greece",
    "GL": "Greenland",
    "GD": "Grenada",
    "GP": "Guadeloupe",
    "GU": "Guam",
    "GT": "Guatemala",
    "GG": "Guernsey",
    "GN": "Guinea",
    "GW": "Guinea-Bissau",
    "GY": "Guyana",
    "HT": "Haiti",
    "VA": "Holy See (Vatican City State)",
    "HN": "Honduras",
    "HK": "Hong Kong",
    "HU": "Hungary",
    "IS": "Iceland",
    "IN": "India",
    "ID": "Indonesia",
    "IR": "Iran, Islamic Republic of Persian Gulf",
    "IQ": "Iraq",
    "IE": "Ireland",
    "IM": "Isle of Man",
    "IL": "Israel",
    "IT": "Italy",
    "JM": "Jamaica",
    "JP": "Japan",
    "JE": "Jersey",
    "JO": "Jordan",
    "KZ": "Kazakhstan",
    "KE": "Kenya",
    "KI": "Kiribati",
    "KP": "Korea, Democratic People's Republic of Korea",
    "KR": "Korea, Republic of South Korea",
    "KW": "Kuwait",
    "KG": "Kyrgyzstan",
    "LA": "Laos",
    "LV": "Latvia",
    "LB": "Lebanon",
    "LS": "Lesotho",
    "LR": "Liberia",
    "LY": "Libyan Arab Jamahiriya",
    "LI": "Liechtenstein",
    "LT": "Lithuania",
    "LU": "Luxembourg",
    "MO": "Macao",
    "MK": "Macedonia",
    "MG": "Madagascar",
    "MW": "Malawi",
    "MY": "Malaysia",
    "MV": "Maldives",
    "ML": "Mali",
    "MT": "Malta",
    "MH": "Marshall Islands",
    "MQ": "Martinique",
    "MR": "Mauritania",
    "MU": "Mauritius",
    "YT": "Mayotte",
    "MX": "Mexico",
    "FM": "Micronesia, Federated States of Micronesia",
    "MD": "Moldova",
    "MC": "Monaco",
    "MN": "Mongolia",
    "ME": "Montenegro",
    "MS": "Montserrat",
    "MA": "Morocco",
    "MZ": "Mozambique",
    "MM": "Myanmar",
    "NA": "Namibia",
    "NR": "Nauru",
    "NP": "Nepal",
    "NL": "Netherlands",
    "AN": "Netherlands Antilles",
    "NC": "New Caledonia",
    "NZ": "New Zealand",
    "NI": "Nicaragua",
    "NE": "Niger",
    "NG": "Nigeria",
    "NU": "Niue",
    "NF": "Norfolk Island",
    "MP": "Northern Mariana Islands",
    "NO": "Norway",
    "OM": "Oman",
    "PK": "Pakistan",
    "PW": "Palau",
    "PS": "Palestine",
    "PA": "Panama",
    "PG": "Papua New Guinea",
    "PY": "Paraguay",
    "PE": "Peru",
    "PH": "Philippines",
    "PN": "Pitcairn",
    "PL": "Poland",
    "PT": "Portugal",
    "PR": "Puerto Rico",
    "QA": "Qatar",
    "RO": "Romania",
    "RU": "Russia",
    "RW": "Rwanda",
    "RE": "Reunion",
    "BL": "Saint Barthelemy",
    "SH": "Saint Helena, Ascension and Tristan Da Cunha",
    "KN": "Saint Kitts and Nevis",
    "LC": "Saint Lucia",
    "MF": "Saint Martin",
    "PM": "Saint Pierre and Miquelon",
    "VC": "Saint Vincent and the Grenadines",
    "WS": "Samoa",
    "SM": "San Marino",
    "ST": "Sao Tome and Principe",
    "SA": "Saudi Arabia",
    "SN": "Senegal",
    "RS": "Serbia",
    "SC": "Seychelles",
    "SL": "Sierra Leone",
    "SG": "Singapore",
    "SK": "Slovakia",
    "SI": "Slovenia",
    "SB": "Solomon Islands",
    "SO": "Somalia",
    "ZA": "South Africa",
    "SS": "South Sudan",
    "GS": "South Georgia and the South Sandwich Islands",
    "ES": "Spain",
    "LK": "Sri Lanka",
    "SD": "Sudan",
    "SR": "Suriname",
    "SJ": "Svalbard and Jan Mayen",
    "SZ": "Swaziland",
    "SE": "Sweden",
    "CH": "Switzerland",
    "SY": "Syrian Arab Republic",
    "TW": "Taiwan",
    "TJ": "Tajikistan",
    "TZ": "Tanzania, United Republic of Tanzania",
    "TH": "Thailand",
    "TL": "Timor-Leste",
    "TG": "Togo",
    "TK": "Tokelau",
    "TO": "Tonga",
    "TT": "Trinidad and Tobago",
    "TN": "Tunisia",
    "TR": "Turkey",
    "TM": "Turkmenistan",
    "TC": "Turks and Caicos Islands",
    "TV": "Tuvalu",
    "UG": "Uganda",
    "UA": "Ukraine",
    "AE": "United Arab Emirates",
    "GB": "United Kingdom",
    "US": "United States",
    "UY": "Uruguay",
    "UZ": "Uzbekistan",
    "VU": "Vanuatu",
    "VE": "Venezuela",
    "VN": "Vietnam",
    "VG": "Virgin Islands, British",
    "VI": "Virgin Islands, U.S.",
    "WF": "Wallis and Futuna",
    "YE": "Yemen",
    "ZM": "Zambia",
    "ZW": "Zimbabwe"
    // "AF": "Afghanistan",
    // "AX": "Åland Islands",
    // "AL": "Albania",
    // "DZ": "Algeria",
    // "AS": "American Samoa",
    // "AD": "Andorra",
    // "AO": "Angola",
    // "AI": "Anguilla",
    // "AG": "Antigua and Barbuda",
    // "AR": "Argentina",
    // "AM": "Armenia",
    // "AW": "Aruba",
    // "AU": "Australia",
    // "AT": "Austria",
    // "AZ": "Azerbaijan",
    // "BS": "Bahamas",
    // "BH": "Bahrain",
    // "BD": "Bangladesh",
    // "BB": "Barbados",
    // "BY": "Belarus",
    // "BE": "Belgium",
    // "BZ": "Belize",
    // "BJ": "Benin",
    // "BM": "Bermuda",
    // "BT": "Bhutan",
    // "BO": "Bolivia",
    // "BA": "Bosnia and Herzegovina",
    // "BW": "Botswana",
    // "BV": "Bouvet Island",
    // "BR": "Brazil",
    // "IO": "British Indian Ocean Territory",
    // "VG": "British Virgin Islands",
    // "BN": "Brunei",
    // "BG": "Bulgaria",
    // "BF": "Burkina Faso",
    // "BI": "Burundi",
    // "KH": "Cambodia",
    // "CM": "Cameroon",
    // "CA": "Canada",
    // "CV": "Cape Verde",
    // "KY": "Cayman Islands",
    // "CF": "Central African Republic",
    // "TD": "Chad",
    // "CL": "Chile",
    // "CN": "China",
    // "CX": "Christmas Island",
    // "CC": "Cocos[Keeling] Islands",
    // "CO": "Colombia",
    // "KM": "Comoros",
    // "CG": "Congo - Brazzaville",
    // "CK": "Cook Islands",
    // "CR": "Costa Rica",
    // "CI": "Côte d’Ivoire",
    // "HR": "Croatia",
    // "CU": "Cuba",
    // "CW": "Curacao",
    // "CY": "Cyprus",
    // "CZ": "Czech Republic",
    // "CD": "Congo - Kinshasa",
    // "DK": "Denmark",
    // "DJ": "Djibouti",
    // "DM": "Dominica",
    // "DO": "Dominican Republic",
    // "EC": "Ecuador",
    // "EG": "Egypt",
    // "SV": "El Salvador",
    // "GQ": "Equatorial Guinea",
    // "ER": "Eritrea",
    // "EE": "Estonia",
    // "ET": "Ethiopia",
    // "FK": "Falkland Islands",
    // "FO": "Faroe Islands",
    // "FJ": "Fiji",
    // "FI": "Finland",
    // "FR": "France",
    // "GF": "French Guiana",
    // "PF": "French Polynesia",
    // "TF": "French Southern Territories",
    // "FQ": "French Southern and Antarctic Territories",
    // "GA": "Gabon",
    // "GM": "Gambia",
    // "GE": "Georgia",
    // "DE": "Germany",
    // "GH": "Ghana",
    // "GI": "Gibraltar",
    // "GR": "Greece",
    // "GL": "Greenland",
    // "GD": "Grenada",
    // "GP": "Guadeloupe",
    // "GU": "Guam",
    // "GT": "Guatemala",
    // "GN": "Guinea",
    // "GW": "Guinea - Bissau",
    // "GY": "Guyana",
    // "HT": "Haiti",
    // "HM": "Heard Island and McDonald Islands",
    // "HN": "Honduras",
    // "HK": "Hong Kong SAR China",
    // "HU": "Hungary",
    // "IS": "Iceland",
    // "IN": "India",
    // "ID": "Indonesia",
    // "IR": "Iran",
    // "IQ": "Iraq",
    // "IL": "Israel",
    // "IE": "Ireland",
    // "IT": "Italy",
    // "JM": "Jamaica",
    // "JP": "Japan",
    // "JO": "Jordan",
    // "KZ": "Kazakhstan",
    // "KE": "Kenya",
    // "KI": "Kiribati",
    // "KW": "Kuwait",
    // "KG": "Kyrgyzstan",
    // "LA": "Laos",
    // "LV": "Latvia",
    // "LB": "Lebanon",
    // "LS": "Lesotho",
    // "LR": "Liberia",
    // "LY": "Libya",
    // "LI": "Liechtenstein",
    // "LT": "Lithuania",
    // "LU": "Luxembourg",
    // "MO": "Macau SAR China",
    // "MK": "Macedonia",
    // "MG": "Madagascar",
    // "MW": "Malawi",
    // "MY": "Malaysia",
    // "MV": "Maldives",
    // "ML": "Mali",
    // "MT": "Malta",
    // "MH": "Marshall Islands",
    // "MQ": "Martinique",
    // "MR": "Mauritania",
    // "MU": "Mauritius",
    // "YT": "Mayotte",
    // "MX": "Mexico",
    // "FM": "Micronesia",
    // "MD": "Moldova",
    // "MC": "Monaco",
    // "MN": "Mongolia",
    // "ME": "Montenegro",
    // "MS": "Montserrat",
    // "MA": "Morocco",
    // "MZ": "Mozambique",
    // "MM": "Myanmar[Burma]",
    // "NA": "Namibia",
    // "NR": "Nauru",
    // "NP": "Nepal",
    // "NL": "Netherlands",
    // "AN": "Netherlands Antilles",
    // "NC": "New Caledonia",
    // "NZ": "New Zealand",
    // "NI": "Nicaragua",
    // "NE": "Niger",
    // "NG": "Nigeria",
    // "NU": "Niue",
    // "NF": "Norfolk Island",
    // "KP": "North Korea",
    // "MP": "Northern Mariana Islands",
    // "NO": "Norway",
    // "OM": "Oman",
    // "PK": "Pakistan",
    // "PW": "Palau",
    // "PS": "Palestinian Territories",
    // "PA": "Panama",
    // "PG": "Papua New Guinea",
    // "PY": "Paraguay",
    // "PE": "Peru",
    // "PH": "Philippines",
    // "PN": "Pitcairn Islands",
    // "PL": "Poland",
    // "PT": "Portugal",
    // "PR": "Puerto Rico",
    // "QA": "Qatar",
    // "RO": "Romania",
    // "RU": "Russia",
    // "RW": "Rwanda",
    // "RE": "Réunion",
    // "SH": "Saint Helena",
    // "KN": "Saint Kitts and Nevis",
    // "LC": "Saint Lucia",
    // "PM": "Saint Pierre and Miquelon",
    // "VC": "Saint Vincent and the Grenadines",
    // "WS": "Samoa",
    // "SM": "San Marino",
    // "SA": "Saudi Arabia",
    // "SN": "Senegal",
    // "RS": "Serbia",
    // "CS": "Serbia and Montenegro",
    // "SC": "Seychelles",
    // "SL": "Sierra Leone",
    // "SG": "Singapore",
    // "SK": "Slovakia",
    // "SI": "Slovenia",
    // "SB": "Solomon Islands",
    // "SO": "Somalia",
    // "ZA": "South Africa",
    // "GS": "South Georgia and the South Sandwich Islands",
    // "KR": "South Korea",
    // "ES": "Spain",
    // "LK": "Sri Lanka",
    // "SD": "Sudan",
    // "SR": "Suriname",
    // "SJ": "Svalbard and Jan Mayen",
    // "SZ": "Swaziland",
    // "SE": "Sweden",
    // "CH": "Switzerland",
    // "SY": "Syria",
    // "ST": "São Tomé and Príncipe",
    // "TW": "Taiwan",
    // "TJ": "Tajikistan",
    // "TZ": "Tanzania",
    // "TH": "Thailand",
    // "TL": "Timor - Leste",
    // "TG": "Togo",
    // "TK": "Tokelau",
    // "TO": "Tonga",
    // "TT": "Trinidad and Tobago",
    // "TN": "Tunisia",
    // "TR": "Turkey",
    // "TM": "Turkmenistan",
    // "TC": "Turks and Caicos Islands",
    // "TV": "Tuvalu",
    // "UM": "U.S.Minor Outlying Islands",
    // "VI": "U.S.Virgin Islands",
    // "UG": "Uganda",
    // "UA": "Ukraine",
    // "AE": "United Arab Emirates",
    // "GB": "United Kingdom",
    // "GG": "Guernsey",
    // "US": "United States",
    // "UY": "Uruguay",
    // "UZ": "Uzbekistan",
    // "VU": "Vanuatu",
    // "VA": "Vatican City",
    // "VE": "Venezuela",
    // "VN": "Vietnam",
    // "WF": "Wallis and Futuna",
    // "EH": "Western Sahara",
    // "YE": "Yemen",
    // "ZM": "Zambia",
    // "ZW": "Zimbabwe",
}